import React from 'react';
import Image from 'assets/images/empty/EmtpyPage.svg';
import './styles.scss';
import MyButton from '../Button/v1';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from "react-intl";

const EmptyPage = ({ extra, ...props }) => {
  const history = useHistory();
  return (
    <div id="page-not-found" {...props}>
      <img src={Image} />
      <div className="content">
        {extra || (
          <>
            <p><FormattedMessage id="page_not_found.title" /></p>
            <MyButton
              className="btn-primary-custom"
              onClick={() => {
                history.push('/');
              }}
            >
              <FormattedMessage id="page_not_found.back_home" />
            </MyButton>
          </>
        )}
      </div>
    </div>
  );
};
export default EmptyPage;
